import { Carousel } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { useRef } from 'react';
import s from './index.module.css';

import Bg1 from '../../asset/bg1.png';
import Bg2 from '../../asset/bg2.png';
import Bg3 from '../../asset/bg3.png';
import Bg4 from '../../asset/bg4.png';

const BannerCarousel = () => {
  const carouselRef = useRef(null);

  const carouselImages = [
    {
      id: 1,
      url: Bg1,
      title: '庆阳市质量基础设施云平台'
    },
    {
      id: 2,
      url: Bg2,
      title: '专业检测服务平台'
    },
    {
      id: 3,
      url: Bg3,
      title: '权威质量保障'
    },
    {
      id: 4,
      url: Bg4,
      title: '权威质量保障'
    }
  ];

  const handlePrev = () => {
    carouselRef.current?.prev();
  };

  const handleNext = () => {
    carouselRef.current?.next();
  };

  return (
    <div className={s.bannerCarousel}>
      
      <div style={{position: 'absolute', top: '120px',left: '160px', zIndex:9999 }}>
        <img src='/qy.png' style={{width:'100px'}}></img>
      </div>
      
      <Carousel
        ref={carouselRef}
        autoplay
        autoplaySpeed={5000}
        dots={true}
        effect="fade"
      >
        {carouselImages.map((image) => (
          <div key={image.id} className={s.carouselSlide}>
            <div
              className={s.slideBackground}
              style={{ backgroundImage: `url(${image.url})` }}
            >
              <div className={s.slideOverlay} />
            </div>
          </div>
        ))}
      </Carousel>

      {/* 自定义箭头按钮 */}
      <div className={`${s.customArrow} ${s.customArrowPrev}`} onClick={handlePrev}>
        <LeftOutlined />
      </div>
      <div className={`${s.customArrow} ${s.customArrowNext}`} onClick={handleNext}>
        <RightOutlined />
      </div>
    </div>
  );
};

export default BannerCarousel;
